const MobileHomeKpiTile = ({
  value,
  label,
  icon: Icon,
  highlight = false,
  loading = false,
  onClick,
}) => {
  const tileClassName = [
    "installation-subpage-card",
    "mobile-home-kpi-tile",
    highlight && "mobile-home-kpi-tile-alert",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type="button" className={tileClassName} onClick={onClick}>
      <span className="mobile-home-kpi-icon" aria-hidden>
        <Icon />
      </span>
      <span className="mobile-home-kpi-value">{loading ? "—" : value}</span>
      <span className="mobile-home-kpi-label">{label}</span>
    </button>
  );
};

export default MobileHomeKpiTile;
